import React, { useState, useEffect, useRef } from "react"
import Button from "react-bootstrap/lib/Button"

import BubbleCard from "../../ui-components/BubbleCard"
import BrowserLocationHelper from "../../utils/browser_location_helper"

import style from "../index.module.sass"

// ----------------------------------------------------------------------------

const MAX_EXPIRES_TIME = 300000

function PendingPaymentCard(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { expiresAt } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [deadline, setDeadline] = useState(null)
  const timer = useRef(null)

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    if (!expiresAt) {
      return
    }
    timer.current = setInterval(() => {
      setDeadline(computeMinutes())
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  })

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function computeMinutes() {
    const now = new Date()
    const deadline = new Date(expiresAt)
    const diff = deadline - now

    if (diff <= 0 || diff > MAX_EXPIRES_TIME) {
      clearInterval(timer.current)
      return null
    }

    const minutes = Math.floor(diff / 1000 / 60)
    const seconds = Math.floor(diff / 1000 % 60)
    const time = `${minutes}:${seconds}`

    return time
  }

  function handleComplete() {
    const path = `${window.location}/payment`
    BrowserLocationHelper.ChangeURL(path)
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className={style.bubbleContainer}>
      <BubbleCard color="blue">
        <div className={style.inner}>
          <p className={style.alreadyRatedThanks}>
            {I18n.t("pages.orders.show.pending_payment_warn_1")}
          </p>
          {deadline && (
            <p className={style.alreadyRatedTitle}>
              {I18n.t("pages.orders.show.pending_payment_warn_2", {
                minutes: deadline,
              })}
            </p>
          )}
          <Button bsStyle="primary" onClick={handleComplete}>
            {I18n.t("pages.orders.show.pending_payment_warn_cta")}
          </Button>
        </div>
      </BubbleCard>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default PendingPaymentCard
